module.exports = __webpack_public_path__ + "img/6.10158c06.png";